import {RouteComponentProps} from "react-router-dom";

export const ADMISSION_EXPERIENCE_ROUTE = "/workflow/explore/:admissionId";

export type AdmissionExperienceRouteProps = RouteComponentProps<{
  admissionId: string;
}>;
